export enum SpecialRequestTypes {
  specialRequest = 'specialRequest',
  ancillarie = 'ancillarie'
}
